import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NavigationService } from '../services/navigation.service';

@Component({
    selector: 'app-back-button',
    imports: [MatButtonModule, MatIconModule],
    template: `
    <div class="back-button-container">
      @if (navigationService.showBackButton()) {
      <button
        mat-icon-button
        aria-label="Zurück"
        i18n-aria-label="@@core.backButton.ariaLabel"
        (click)="navigationService.goBack()"
      >
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
      </button>
      }
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
      :host {
        display: block;
        width: 40px; /* Width of a mat-icon-button */
      }

      .back-button-container {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
    ]
})
export class BackButtonComponent {
  readonly navigationService = inject(NavigationService);
}
